<template>
  <!--
          作者：kmd
          时间：2021年9月4日 02点02分
          描述：用户结构
      -->
  <div>
    <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="用户"><el-input v-model="formInline.search" placeholder="用户ID或者手机号或者昵称"></el-input></el-form-item>
      <el-form-item label="会员等级" v-if="gradeList && gradeList.length > 0">
        <el-select v-model="formInline.grade_id" placeholder="请选择">
          <el-option label="全部" value="0"></el-option>
          <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="注册时间">
        <div class="block">
          <span class="demonstration"></span>
          <el-date-picker v-model="formInline.reg_date" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </div>
      </el-form-item>
      <el-form-item><el-button type="primary" icon="el-icon-search" @click="getData(true)">查询</el-button></el-form-item>
    </el-form>

    <el-input
      placeholder="输入关键字进行过滤"
      v-model="filterText">
    </el-input>

    <el-tree class="filter-tree mt30" :data="data" :props="defaultProps" :filter-node-method="filterNode" :load="loadNode" lazy :highlight-current="true" ref="tree">
      <div class="custom-tree-node" slot-scope="{ node, data }">
        <div class="avatar-image">
          <!--<img :src="data.avatarUrl" width="40px" height="40px" v-if="data.avatarUrl" />-->
          <el-avatar size="medium" icon="el-icon-user-solid" :src="data.avatarUrl"></el-avatar>
        </div>
        <div class="text-box">
          <span class="lh30">[用户ID: {{ data.user_id }}]</span>
          <span v-if="data.nickName"> 昵称: {{ data.nickName }}</span>
          <el-tag type="info">{{ data.grade_name }}</el-tag>
          <span v-if="data.referee_count > 0">直推: {{ data.referee_count }}人</span>
          <el-button type="success" plain v-if="data.referee_id > 0" @click.stop="getSuperior(data.user_id)">查找上级</el-button>
        </div>
      </div>
    </el-tree>
    <ShowParent :open="is_open_parent" :parentList="parentList" :initial_user_id="initial_user_id" @close="closeParent"></ShowParent>

    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="formInline.page" :page-size="formInline.list_rows" :page-sizes="[5, 10, 15, 20, 30, 40, 50, 60, 70, 80, 90, 100]" layout="total, sizes, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import UserApi from '@/api/user.js';
import ShowParent from './dialog/showParent.vue';
export default {
  components: {
    /*编辑组件*/
    ShowParent
  },
  data() {
    return {
      /*横向表单数据模型*/
      formInline: {
        search:'',
        grade_id: '',
        reg_date: '',
        page: 1,
        list_rows: 10,
      },
      parentList:[],
      totalDataNumber: 0,
      gradeList: null,
      filterText: '',
      data: null,
      defaultProps: {
        children: 'children',
        label: 'label',
        isLeaf: 'leaf'
      },
      is_open_parent:false,
      initial_user_id: 0,
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.formInline.search = this.$route.query.user_id
    this.getData()
  },
  methods: {
    /*关闭添加*/
    closeParent(e) {
      this.is_open_parent = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.nickName.indexOf(value) !== -1;
    },

    loadNode(node, resolve) {
      if (node.level === 0) {
        return false
      }
      UserApi.getChildren({ parent_id: node.data.user_id })
        .then(res => {
          return resolve(res.data.list);
        }).catch(error => {});
    },

    getSuperior(user_id){
      UserApi.getSuperior({ user_id })
        .then(res => {
          this.parentList = res.data.list;
          this.is_open_parent = true;
          this.initial_user_id = user_id
        }).catch(error => {});
    },

    getData(query) {
      const self = this
      self.loading = true
      if (query) {
        self.formInline.page = 1
      }
      UserApi.userStructure(this.formInline)
        .then(res => {
          self.loading = false
          self.data = res.data.list.data
          self.totalDataNumber = res.data.list.total
          self.gradeList = res.data.grade
        }).catch(error => {});
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.formInline.page = 1
      this.formInline.list_rows = val
      this.getData()
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.formInline.page = val
      this.getData()
    },

  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-tree-node__content {
  height: 50px;
}
/deep/ .is-current {
  border: #111111 1.5px solid;
}
.custom-tree-node {
  display: flex;
  vertical-align: center;
  .avatar-image {
    display: inline-block;
    border-radius: 30px;
    overflow: hidden;
  }
  .text-box {
    margin-left: 8px;
    display: inline-block;
    line-height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/userstructure/userstructure.vue